import { Dimensions, Image, ScrollView, StyleSheet, Text, TouchableOpacity, View, Modal, Animated } from 'react-native';
import { CardQuestion } from './components/questions/CardQuestion';
import test, { FONT_STYLE } from './dataSchema/const';
import { useFonts } from 'expo-font';
import * as SplashScreen from 'expo-splash-screen';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import ResultPopUp from './components/ResultPopUp';
import { API, MobileForm, FormDataType } from './api/api';
import { DATA_SERVICE } from './dataSchema/DataService';
import Toast from 'react-native-toast-message';
import { TELE_ALERT } from './api/tele';
import { getEnv } from './api/Enviroment';
// import { mockData } from './mock-data';

SplashScreen.preventAutoHideAsync();

type ErrorText = {
  title: string,
  desc: string
}

const objectError: Record<string, ErrorText> = {
  '500': {
    title: "Có gì đó không đúng",
    desc: "Bạn hãy thử kiếm tra lại thông tin một lần nữa nhé"
  },
  '3006': {
    title: "Có gì đó không đúng",
    desc: "Bạn hãy thử kiếm tra lại thông tin một lần nữa nhé"
  },
  '3002': {
    title: 'Khảo sát này chưa sẵn sàng',
    desc: 'Hãy quay lại sau để tham gia cùng chúng tôi nhé.'
  },
  '3003': {
    title: 'Bạn đến sớm quá rồi',
    desc: 'Khảo sát sẽ mở trong thời gian tới, nhớ ghé lại nha.'
  },
  '3004': {
    title: 'Khảo sát này đã khép lại rồi',
    desc: 'Hẹn bạn ở những khảo sát mới thú vị hơn nhé.'
  },
  '3000': {
    title: 'Bạn đã hoàn thành khảo sát này rồi',
    desc: 'Chờ đón thêm nhiều khảo sát khác nhé.'
  },
  '3001': {
    title: 'Khảo sát này chưa phù hợp với bạn',
    desc: 'Đừng lo, sẽ có những khảo sát khác dành cho bạn sớm thôi.'
  },
  '3005': {
    title: 'Khảo sát này đã đủ số lượt tham gia',
    desc: 'Hẹn gặp bạn ở khảo sát tiếp theo nhé.',
  },
  'default': {
    title: `Khu vực đang thi công`,
    desc: `Hẹn gặp bạn tại khảo sát khác vui hơn nhé.`
  }
}


export default function App() {
  const [fontsLoaded] = useFonts({
    ArchiaMedium: require('./assets/fonts/Archia-Medium.ttf'),
    ArchiaBold: require('./assets/fonts/Archia-Bold.ttf'),
  });
  const [loading, showloading] = useState(true);
  const [question, SetQuestion] = useState([])
  const [formData, setFormData] = useState<FormDataType | null>(null);
  const [result, setResult] = useState(null);
  const [answers, setAnswerSurvey] = useState([]);
  const [answerCount, setAnswerCount] = useState(0);
  const [canSubmit, setSubmitIssue] = useState(false);
  const [isSubmited, setSubmited] = useState(false);
  const [currentPage, setPage] = useState(null);
  const pageIndexRef = useRef(0);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isBottom, setIsBottom] = useState(false);

  const [errorCode, setErrorCode] = useState<string | null>(null)

  const scrollViewRef = useRef(null);

  const scrollToTop = () => {
    scrollViewRef.current?.scrollTo({ x: 0, y: 0, animated: true });
  };


  const fetchData = async () => {
    try {
      const surveyResult = await API.fetchAuthData();
      showloading(false);

      if (surveyResult) {

        if (!surveyResult.status.success) {
          let errorCodeTempt = surveyResult.status.appCode.toString();
          if (
            errorCodeTempt === '3001' &&
            surveyResult.status.detail !== "[E3001] The user is not in the segment of this form."
          ) {
            errorCodeTempt = "500"
          }
          setErrorCode(errorCodeTempt)
          return;
        }
        let result: FormDataType = surveyResult.data as FormDataType;

        setFormData(result);
        setPage(result.mobileForm.pageForms[pageIndexRef.current]);
        filterQuestion(result.mobileForm.pageForms[pageIndexRef.current].questions);
        // listQuestPageCount.current[pageIndexRef.current] = question.length;
      }
    } catch (err) {
      if (getEnv().name === 'prod') {
        const msg = { data: err, token: API._token };
        await TELE_ALERT.alertTelegram(msg);
      }
    }
  }

  useEffect(() => {
    showloading(true)
    fetchData();
    // setFormData(mockData.data as any);
    // setPage(mockData.data.mobileForm.pageForms[pageIndexRef.current] as any);
    // filterQuestion(mockData.data.mobileForm.pageForms[pageIndexRef.current].questions as any);
    // showloading(false)
  }, [])

  useEffect(() => {
    setAnswerCount(answers.length);
    if (formData) {
      let requireAnsCount = 0
      answers.forEach(e => {
        if (e.required) {
          requireAnsCount++;
        }
      })
      setSubmitIssue(requireAnsCount >= question.filter((r) => r.required === true).length);
    }

  }, [answers])

  const filterQuestion = (list) => {
    if (list && list.length) {
      const listQuestion = []
      list.forEach(e => {
        if (!e.depend) {
          listQuestion.push(e);
        } else {
          answers.forEach(i => {
            if (e.questionDependId === i.questionId) {
              if (hasCommonElement(i.values, e.answerDepend)) {
                listQuestion.push(e);
              }
            }
          })
        }
      })
      SetQuestion(listQuestion);
      if (question.length <= 3)
        setIsBottom(true);
    }
  }

  const toastConfig = {
    customToast: (params: { text1?: string }) => (
      <View
        style={{
          width: 262,
          height: 48,
          padding: 12,
          backgroundColor: '#FF4C4D',
          borderRadius: 42,
          alignSelf: 'center',
          flexDirection: 'row',
          justifyContent: "space-between"
        }}
      >
        <Image source={require('./assets/IconError.png')} style={{ width: 20, height: 20 }}></Image>
        <Text style={{
          fontSize: 10,
          fontFamily: FONT_STYLE.MEDIUM,
          color: 'white',
          marginTop: 5,
        }}>{params.text1 ?? ''}</Text>
        <Image source={require('./assets/Close.png')} style={{ width: 20, height: 20 }}></Image>
      </View>
    ),
  };

  const onPressPage = (index) => {
    // listQuestPageCount.current[pageIndexRef.current] = question.length;
    pageIndexRef.current = index;
    setPage(formData.mobileForm.pageForms[pageIndexRef.current]);
    filterQuestion(formData.mobileForm.pageForms[pageIndexRef.current].questions)
    setTimeout(() => {
      scrollToTop();
    }, 150);
  }

  const showToast = () => {
    Toast.show({
      type: 'customToast',
      text1: 'Bạn chưa hoàn thành hết câu trả lời!',
      position: 'top',
    });
  };

  const handleScroll = (event) => {
    const { layoutMeasurement, contentOffset, contentSize } = event.nativeEvent;
    const atBottom = contentOffset.y + layoutMeasurement.height >= contentSize.height - 10;

    if (atBottom && formData) {
      setIsBottom(true);
    } else {
      if (question.length > 3)
        setIsBottom(false);
    }
  };

  const onSetAnswerMulti = (answer) => {
    if (answer) {
      for (let a of answers) {
        if (a.questionId === answer.questionId) {
          let depends = currentPage.questions.filter((e) => e.questionDependId === answer.questionId);
          let i = 0;
          for (let d of depends) {
            if (!hasCommonElement(answer.values, d.answerDepend,)) {
              for (let item of answers) {
                if (item.questionId === d.id) {
                  let index = answers.indexOf(item);
                  answers.splice(index, 1);
                }
              }

              let index = -1;
              question.forEach((e, i) => {
                if (e.id === d.id) {
                  index = i;
                }
              });
              if (question[index])
                if (!hasCommonElement(answer.values, question[index].answerDepend))
                  question.splice(index, 1);
              if (answer.values.length === 0 || !answer.values) {
                setAnswerSurvey(answers.filter((a) => a.questionId !== answer.questionId))
                return;
              }

            } else {
              let index = -1;
              question.forEach((e, i) => {
                if (e.id === answer.questionId) {
                  index = i;
                }
              });
              let haveThisQuestion = false;
              for (let i of question) {
                if (i.id === d.id) {
                  haveThisQuestion = true;
                }
              }
              if (!haveThisQuestion)
                question.splice(index + i + 1, 0, d);
            }
            i++;
          }
          let index = answers.indexOf(a);
          answers.splice(index, 1);
          setAnswerSurvey([...answers, answer])
          return;
        }
      }
      let depends = currentPage.questions.filter((e) => e.questionDependId === answer.questionId);
      depends.forEach((d, i) => {
        if (hasCommonElement(answer.values, d.answerDepend)) {
          let index = -1;
          question.forEach((e, i) => {
            if (e.id === answer.questionId) {
              index = i;
            }
          });
          let haveThisQuestion = false;
          for (let i of question) {
            if (i.id === d.id) {
              haveThisQuestion = true;
            }
          }
          if (!haveThisQuestion)
            question.splice(index + 1 + i, 0, d);
        }
      })
      setAnswerSurvey([...answers, answer])
    }
    else {
      setAnswerSurvey(answers.filter((a) => a.questionId !== answer.questionId))
    }

  }


  const hasCommonElement = (arr1, arr2) => {
    return arr1.some((item) => arr2.includes(typeof item === "number" ? `${item}` : item));
  };

  const requireQuestion = () => {
    let requiredCount = 0;
    let requiredCountPage = question.filter((r) => r.required === true).length;
    currentPage?.questions?.forEach(e => {
      answers.forEach(a => {
        if (a.questionId === e.id && e.required) {
          requiredCount++;
        }
      })
    });
    return requiredCount >= requiredCountPage;
  }

  const onSubmitSurvey = async () => {
    if (answers && answers.length) {
      for (let ans of answers) {
        formData.mobileForm.pageForms.forEach(e => {
          e.questions.forEach(q => {
            if (q.id === ans.questionId) {
              if (ans.values.length === 0) {
                return
              }
            }
          });
        })
      }
    }

    const leaderboardId = DATA_SERVICE.data.credential.leaderboardId;
    const submitData = {
      formId: leaderboardId,
      userId: DATA_SERVICE.data.credential.userId || '',
      answers: answers
    }

    // Check if SOB and userId null then send message instead of API
    if (formData.mobileForm.action === 'SOB' && ['undefined', 'null'].includes(formData.credential.userId)) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify({
        action: 'submit',
        data: submitData
      }));
      console.log('WEBVIEW SUBMIT')
      return;
    } else {
      console.log("API SUBMIT")
    }


    try {
      const resultData = await API.submitSurveyData(submitData);
      if (resultData) {
        setResult(resultData);
        setIsPopupVisible(true);
        setSubmited(true);
        if (getEnv().name === 'stag') {
          const msg = { data: resultData, payload: submitData };
          TELE_ALERT.alertTelegramSubmitFail(msg);
        }
      }
    } catch (error) {
      if (getEnv().name === 'stag') {
        const msg = { data: error, payload: submitData };
        TELE_ALERT.alertTelegramSubmitFail(msg);
      }
    }
  }

  const exitWebview = () => {
    if ((window as any)?.ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify({ action: 'back' }));
    }

  }

  const checkContinue = () => {

    if (requireQuestion())
      onPressPage(pageIndexRef.current + 1);
    else
      showToast();
  }

  const renderButtonBottom = () => {
    if (pageIndexRef.current === 0) {
      return (
        <TouchableOpacity onPress={() => {
          if (formData.mobileForm.pageForms.length > 1)
            checkContinue()
          else if (requireQuestion())
            onSubmitSurvey();
          else showToast();
        }}>
          <View style={styles.submitBtn}><Text style={styles.submitLabel}>{formData?.mobileForm.pageForms?.length > 1 ? `Tiếp tục` : 'Hoàn thành'}</Text>
          </View>
        </TouchableOpacity>)
    } else if (pageIndexRef.current === formData.mobileForm.pageForms.length - 1) {
      return (
        <View style={styles.bottom_btn}>
          <TouchableOpacity onPress={() => { onPressPage(pageIndexRef.current - 1) }}>
            <View style={styles.back_btn_bottom}>
              <Text style={styles.backLabel}>{`Quay lại`}</Text>
            </View>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => {
            if (requireQuestion())
              onSubmitSurvey();
            else
              showToast();
          }}>
            <View style={styles.nex_btn_bottom}>
              <Text style={styles.submitLabel}>{`Hoàn thành`}</Text>
            </View>
          </TouchableOpacity>
        </View>
      )
    } else {
      return (
        <View style={styles.bottom_btn}>
          <TouchableOpacity onPress={() => { onPressPage(pageIndexRef.current - 1) }}>
            <View style={styles.back_btn_bottom}>
              <Text style={styles.backLabel}>{`Quay lại`}</Text>
            </View>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => { checkContinue() }}>
            <View style={styles.nex_btn_bottom}>
              <Text style={styles.submitLabel}>{`Tiếp theo`}</Text>
            </View>
          </TouchableOpacity>
        </View>
      )
    }
  }

  const onLayoutRootView = useCallback(async () => {
    if (fontsLoaded) {
      await SplashScreen.hideAsync();
    }
  }, [fontsLoaded]);

  if (!fontsLoaded) {
    return null;
  }

  return (

    <>
      {
        loading ? (
          <View style={styles.container}>
          </View>
        ) : (
          <View style={styles.container}>
            <View style={styles.scrollViewWrapper}>
              <ScrollView
                horizontal={false}
                ref={scrollViewRef}
                scrollEnabled={true}
                onScroll={handleScroll} scrollEventThrottle={16}
              >
                <View style={styles.surveyHeader}>
                  <Text style={styles.surveytitle}>{currentPage && currentPage.title && currentPage.title.length ? `${currentPage.title}` : ``}</Text>
                  {
                    currentPage && currentPage.imageUrl && currentPage.imageUrl.length ? (
                      <Image style={{ width: 343, height: 171, resizeMode: 'center' }} source={{ uri: currentPage ? currentPage.imageUrl : `` }}></Image>
                    ) : null
                  }
                </View>
                {
                  !errorCode && (
                    question.map((question) => {
                      const defaultAnswer = answers.filter((answer) => answer.questionId == question.id)[0];

                      return (
                        <CardQuestion
                          data={question}
                          key={question.id}
                          answerHandle={onSetAnswerMulti}
                          defaultAnswer={defaultAnswer}
                        />
                      )
                    })
                  )
                }
                {
                  errorCode && (
                    <View style={styles.failPopUp}>
                      <Image style={{ width: 180, height: 130 }} source={require('./assets/Error.png')}></Image>
                      <Text style={{ fontFamily: FONT_STYLE.BOLD, fontSize: 20, marginTop: 15 }}>
                        {objectError[errorCode ?? "default"].title}
                      </Text>
                      <Text style={{ fontFamily: FONT_STYLE.MEDIUM, fontSize: 16, marginTop: 15, width: '85%', textAlign: 'center' }}>{objectError[errorCode ?? "default"].desc}</Text>
                    </View>
                  )
                }
                <View>
                  {
                    // data?.pageForms && data?.pageForms.length > 1 ?
                    //   (
                    //     <View style={styles.pageSelect}>
                    //       {
                    //         Array.from({ length: data.pageForms.length }, (_, i) => i).map(item => {
                    //           return (
                    //             <View
                    //               style={[styles.pageButton, item == pageIndexRef.current ? {
                    //                 borderRadius: 10,
                    //                 borderWidth: 1,
                    //                 borderColor: '#F65D79'
                    //               } : {}]}
                    //               key={item}
                    //             >
                    //               <Text style={{
                    //                 color: '#F65D79',
                    //                 fontFamily: FONT_STYLE.MEDIUM,
                    //                 fontSize: 16,
                    //                 textAlign: 'center'
                    //               }}>{`${item + 1}`}</Text>
                    //             </View>
                    //           );
                    //         })
                    //       }
                    //     </View>
                    //   )
                    //   : null
                  }
                  <View style={{ height: 154 }}></View>
                </View>

              </ScrollView>

              {isBottom ? (<View style={styles.footer}>
                <Text style={styles.footerText}>{`Bạn đã hoàn thành ${answerCount} câu khảo sát`}</Text>
                {renderButtonBottom()}
              </View>) : null}
            </View>
            {
              isSubmited && !isPopupVisible ? (
                <Modal
                  transparent={true}
                  animationType="fade"
                  visible={isSubmited}
                  focusable={false}
                >
                  <View style={styles.overlay}>
                  </View>
                </Modal>
              ) : null
            }
            {
              result && !isPopupVisible ? null : (
                <Modal
                  transparent={true}
                  animationType="fade"
                  visible={isPopupVisible}
                  onRequestClose={() => setIsPopupVisible(false)}
                  focusable={false}
                >
                  <View style={styles.overlay}>
                    <ResultPopUp data={result} handleClose={() => {
                      setIsPopupVisible(false);
                      exitWebview();
                    }} />
                  </View>
                </Modal>
              )
            }
          </View>
        )
      }
      <Toast config={toastConfig}></Toast>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#EFF3F6'
  },
  header: {
    height: 92,
    backgroundColor: '#FFFFFF',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  title: {
    fontFamily: FONT_STYLE.BOLD,
    textAlign: 'center',
    fontSize: 16,
    top: 45,
    width: 245,
    position: 'absolute'
  },
  back_btn: {
    width: 18,
    height: 18,
    left: 15,
    top: 56,
    position: 'absolute'
  },
  back_icon: {
    width: '100%',
    height: '100%',
    tintColor: '#000000'
  },
  scrollViewWrapper: {
    height: Dimensions.get("window").height,
  },
  footer: {
    position: "absolute",
    bottom: 0,
    width: '100%',
    backgroundColor: '#FFFFFF',
    height: 126,
    marginTop: 50,
    padding: 15,
    justifyContent: 'center',
    flexDirection: 'column',
    alignContent: 'center',
  },
  footerText: {

    textAlign: 'center',
    fontSize: 14,
    fontFamily: ' ArchiaMedium',
  },
  submitBtn: {
    borderRadius: 10,
    backgroundColor: "#F65D79",
    marginTop: 15,
    height: 44,
    alignContent: "center",
    justifyContent: "center",
  },
  submitLabel: {
    color: "#FFFFFF",
    textAlign: "center",
    fontSize: 14,
    fontFamily: FONT_STYLE.MEDIUM,
  },
  backLabel: {
    color: "#000000",
    textAlign: "center",
    fontSize: 14,
    fontFamily: FONT_STYLE.MEDIUM,
  },
  errorNode: {
    backgroundColor: 'white',
    height: 30
  },
  errorLabel: {
    color: 'red',
    fontSize: 14,
    fontFamily: FONT_STYLE.MEDIUM,
    textAlign: 'center',
    marginLeft: 15
  },
  pageSelect: {
    height: 50,
    justifyContent: 'center',
    flexDirection: 'row',
    padding: 10
  },
  pageButton: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    margin: 5,
  },
  overlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  surveyHeader: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 15
  },
  surveytitle: {
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 16,
    lineHeight: 20,
    textAlign: 'center',
    width: '80%',
  },
  failPopUp: {
    height: Dimensions.get("window").height,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#EFF3F6'
  },
  back_btn_bottom: {
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#d3d3d3',
    width: 164,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center'
  },
  nex_btn_bottom: {
    backgroundColor: '#F65D79',
    borderRadius: 10,
    width: 164,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center'
  },
  bottom_btn: {
    width: '100%',
    height: 64,
    marginTop: 5,
    alignContent: 'center',
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 5
  }
});
